import Vue from "vue";
import {
  CONTRACT_RESOURCE,
  READ_ACTION,

  BUSINESS_SCHOOL_PREPOSTO,
  BUSINESS_SCHOOL_FRANQUEADO,
  BUSINESS_SCHOOL_EXPANSAO

} from "@/constants/resources";

// Observable para que o submenu "Colaborador" possa ter href/disabled/tag
// atualizados em runtime (ver LayoutVertical.vue) e o menu re-renderizar.
export default Vue.observable([
  {
    title: "Futuro Academy",
    icon: "none",
    resource: CONTRACT_RESOURCE,
    action: READ_ACTION,
    children: [
      {
        title: "Preposto",
        menuKey: "business-school-partners",
        href: "https://futuroconsultoriafinanceira.curseduca.pro/courses?tenant=parceiros",
        icon: "BookOpenIcon",
        resource: BUSINESS_SCHOOL_PREPOSTO,
        action: READ_ACTION,
      },
      {
        title: "Franqueado Planejador",
        menuKey: "business-school-franqueados",
        href: "https://futuroconsultoriafinanceira.curseduca.pro/courses?tenant=franqueados",
        icon: "BookOpenIcon",
        resource: BUSINESS_SCHOOL_FRANQUEADO,
        action: READ_ACTION,
      },
      {
        title: "Franqueado Expansão",
        menuKey: "business-school-expansao",
        href: "https://futuroconsultoriafinanceira.curseduca.pro/courses?tenant=franqueados",
        icon: "BookOpenIcon",
        resource: BUSINESS_SCHOOL_EXPANSAO,
        action: READ_ACTION,
      },
      {
        title: "Códex",
        menuKey: "futuro-academy-codex",
        href: null,
        icon: "BookOpenIcon",
        anyOfResources: [
          BUSINESS_SCHOOL_PREPOSTO,
          BUSINESS_SCHOOL_FRANQUEADO,
          BUSINESS_SCHOOL_EXPANSAO,
        ],
        action: READ_ACTION,
        disabled: true,
        tag: "Em breve",
        tagVariant: "secondary",
      },
    ],
  },
]);
